// extracted by mini-css-extract-plugin
module.exports = {"loadableImageContainer":"use-load-assets_loadableImageContainer___yC9d"};